export enum formTypeEnum {
    textFieldInline = 'textFieldInline',
    customTextField = 'customTextField'
}
